import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import './ThankYou.css';

const ThankYou = () => {
  return (
    <div className="thank-you-page">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/">
            <img
              src={`${process.env.PUBLIC_URL}/assets/gnp-logo01.webp`}
              alt="Gardens of North Port"
              className="logo-image"
            />
          </Link>
        </div>

        <ul className="navbar-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/#care-options">Care Options</Link></li>
          <li><Link to="/#amenities">Amenities</Link></li>
          <li><Link to="/#residences">Residences</Link></li>
          <li><Link to="/#testimonials">Testimonials</Link></li>
        </ul>

        <div className="navbar-cta">
          <span className="navbar-phone-text">(941) 249-2344</span>
          <a href="tel:9412492344" className="navbar-phone-btn" aria-label="Call us">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.6 10.8C7.8 13.2 9.8 15.2 12.2 16.4L14.1 14.5C14.35 14.25 14.7 14.18 15 14.32C16.05 14.7 17.2 14.9 18.4 14.9C18.9 14.9 19.3 15.3 19.3 15.8V18.4C19.3 18.9 18.9 19.3 18.4 19.3C10.3 19.3 3.7 12.7 3.7 4.6C3.7 4.1 4.1 3.7 4.6 3.7H7.2C7.7 3.7 8.1 4.1 8.1 4.6C8.1 5.8 8.3 6.95 8.68 8C8.82 8.3 8.75 8.65 8.5 8.9L6.6 10.8Z" fill="currentColor" />
            </svg>
          </a>
        </div>
      </nav>

      {/* Body */}
      <div className="thank-you-body">
        <img
          src={`${process.env.PUBLIC_URL}/assets/thank-you-like.png`}
          alt="Thank you"
          className="thank-you-img"
        />

        <h1 className="thank-you-heading">
          Thank You for Reaching Out to Gardens of North Port!
        </h1>

        <p className="thank-you-subtext">
          We're delighted by your interest in our community. A member of our caring team
          will be in touch shortly to answer your questions, discuss care options, and
          schedule your tour — at no cost and with no obligation.
        </p>

        <Link to="/" className="thank-you-back-btn">Back To Home</Link>
      </div>
    </div>
  );
};

export default ThankYou;
